// Configured TanStack Query client.
//
// Defaults are tuned for this backend:
//  - GET retries once, but NEVER on a 4xx (those won't fix themselves).
//  - mutations don't retry (avoid double-submits against non-idempotent POSTs).
//  - sensible stale/gc times; per-query overrides come from the `STALE_TIME`
//    tiers in config.js.
//
// `@tanstack/react-query` is installed but was never wired into the app — this
// is the client that ApiProvider mounts.

import { QueryClient } from "@tanstack/react-query";
import { GC_TIME, STALE_TIME } from "./config";

const isClientError = (error) => {
  const status = error?.status; // AppError carries `status`
  return typeof status === "number" && status >= 400 && status < 500;
};

export const createQueryClient = () =>
  new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: STALE_TIME.list,
        gcTime: GC_TIME,
        retry: (failureCount, error) => {
          if (isClientError(error)) return false;
          return failureCount < 1;
        },
        refetchOnWindowFocus: false,
        // Errors are already normalized to AppError by the interceptor.
      },
      mutations: {
        retry: false,
      },
    },
  });

// Shared singleton for non-React callers (rare) and tests.
export const queryClient = createQueryClient();
